<template>
  <SPCoreShell>
    <template #filter>
      <v-select class="mb-4" :items="vendorList" item-text="name" item-value="id" label="Select Vendor" multiple outline hide-details />
      <v-treeselect class="spcore-states-treeselect" :value="selectedStates" :multiple="true" :options="states" placeholder="State" @input="stateSelected" />
      <DateRangePicker header="Date Range" :value="liveFilters.dateRange || { from: claimsDate.min, to: claimsDate.max }" :min="claimsDate.min" :max="claimsDate.max" @input="dateSelected" />
    </template>
    <div class="w-100 p-4">
      <div class="spcore-box white p-3">
        <h2 class="hvh-h6">Product Movement</h2>
        <hvh-chart :visualization="visualization"></hvh-chart>
        <div class="splitter mb-3" />
        <div class="prod-line">3PL</div>
        <div class="line-horizontal arrow-right"></div>
        <div class="prod-line">WHOLESALER</div>
        <div class="line-horizontal arrow-right"></div>
        <div class="prod-line">SPECIALTY DISTRIBUTIORS</div>
        <div class="line-horizontal arrow-right"></div>
        <div class="prod-line">SPECIALTY PHARMACIES</div>
        <div class="line-horizontal arrow-right"></div>
        <div class="prod-line">SHIPPED TO PATIENTS</div>
      </div>
    </div>
  </SPCoreShell>
</template>
  
<script>
import { getDemographics } from '../../libraries/cohorts';
import SPCoreShell from '../../components/spcore/SPCoreShell.vue';
import ProductData from '../../components/spcore/data/productmovement.json';
import DateRangePicker from '../../components/common/date/DateRangePicker.vue';
import VTreeselect from '@riophae/vue-treeselect';
export default {
  title: 'Product Movement',
  components: { SPCoreShell, DateRangePicker, VTreeselect },
  data() {
    var states = getDemographics().states
      .reduce((acc, f) => { acc[f.value] = f.text; return acc; }, {});
    return {
      liveFilters: { area: {} },
      visualization: ProductData,
      node: null,
      states: ['Mid West', 'North East', 'South East', 'South West', 'West']
        .map(region => ({
          id: region,
          label: region,
          children: getDemographics()[region]
            .map(f => ({ id: f, label: states[f] }))
        })),
      selectedStates: null,
      claimsDate: { min: new Date('2015-01-01').toISOString(), max: new Date().toISOString() },
      vendorList: [
        { "id": "1", "name": "Vendor 1" },
        { "id": "2", "name": "Vendor 2" },
        { "id": "3", "name": "Vendor 3" },
        { "id": "4", "name": "Vendor 4" }
      ],
    }
  },
  methods: {
    itemClicked(item) {
      // @ts-ignore
      this.node = item;
    },
    stateSelected(event) {
      var states = event.map(f => this.states.find(g => g.id === f) || f)
        .flatMap(f => f.children || [f])
        .map(f => f.id || f);
      this.liveFilters = {
        ...this.liveFilters,
        area: {
          ...this.liveFilters.area,
          states
        }
      };
    },
    dateSelected(event) {
      this.liveFilters = {
        ...this.liveFilters,
        dateRange: event
      };
    },
  }
}
</script>

<style lang="scss" scoped>
.splitter {
  border-top: 1px solid #c6e6e5;
}
</style>